import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Loader2, ShieldAlert } from 'lucide-react';
import useAuthStore from '../store/authStore';

/**
 * Entrada de soporte: el SuperAdmin abre esta ruta con un token temporal (30 min) del
 * administrador de la cuenta, para revisar y corregir (p. ej. un rechazo de Hacienda).
 * Reemplaza cualquier sesión abierta en este navegador.
 */
export default function Impersonar() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const impersonar = useAuthStore(s => s.impersonar);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = params.get('token');
    const slug = params.get('slug');
    // Que el token no quede en el historial ni en la barra de direcciones
    window.history.replaceState(null, '', '/impersonar');
    if (!token || !slug) { setError('Enlace de soporte inválido'); return; }
    impersonar(token, slug).then(ok => {
      if (ok) navigate(params.get('ir') || '/dashboard', { replace: true });
      else setError('El acceso de soporte venció o no es válido. Genere uno nuevo desde la consola.');
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl border border-gray-200 p-8 max-w-md w-full text-center">
        {error ? (
          <>
            <ShieldAlert className="h-10 w-10 text-red-500 mx-auto mb-3" />
            <p className="text-gray-900 font-medium">{error}</p>
          </>
        ) : (
          <>
            <Loader2 className="h-8 w-8 animate-spin text-blue-600 mx-auto mb-3" />
            <p className="text-gray-700">Abriendo la sesión de soporte…</p>
          </>
        )}
      </div>
    </div>
  );
}
